import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { Fabricante } from '../models/fabricante';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { Sistema } from '../models/sistema';
import { FabricanteService, FormulaService } from '../services';
import { AutocolorStore } from '../store/autocolor-store.service.ts.service';
import { NotificacionService } from '../services/notificacion.service';
import { MessageService } from 'primeng/api';
import { FormulaColorView } from '../models/formulacolorview';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-color-search',
  templateUrl: './formula-search.component.html',
  styleUrls: ['./formula-search.component.css']
})
export class FormulaSearchComponent implements OnInit {

  fabricantes: Fabricante[];
  sistemas: Sistema[];
  valoresActivos: Activo[] = [{ nombre: "Activo", valor: 1 }, { nombre: "Inactivo", valor: 0 }, { nombre: "Ambos", valor: null }]
  estadoFormula: Activo;
  isLoading = false;

  codigo: string;
  idformula: string;
  nombre: string;
  chip: string;
  fabricante: Fabricante;
  sistema: Sistema;
  isShown: boolean = false; // oculto por default

  esAdmin: boolean = false;
  busquedaIniciada: boolean = false;
  notificada: boolean = false;


  toggleShow() {

    this.isShown = !this.isShown;

  }

  constructor(
    public colorStore: AutocolorStore,
    private formulaService: FormulaService,
    private fabricanteService: FabricanteService,
    private messageService: MessageService,
    private notificacionService: NotificacionService,
    private keycloackService: KeycloakService,
    private router: Router
  ) { }

  async ngOnInit() {

    this.estadoFormula = { nombre: "Activo", valor: 1 };
    this.nombre = this.colorStore.paramsFormula?.nombrecolor;
    this.codigo = this.colorStore.paramsFormula?.codigocolor;
    this.chip = this.colorStore.paramsFormula?.chip;
    this.idformula = this.colorStore.paramsFormula?.idformula;

    if (this.colorStore.paramsFormula?.idfabricante) {
      this.fabricanteService.getFabricante(this.colorStore.paramsFormula?.idfabricante)
        .subscribe(fab => {
          this.fabricante = fab;
        });
    }

    if (this.colorStore.paramsFormula?.idsistema) {
      this.formulaService.getSistema(this.colorStore.paramsFormula?.idsistema)
        .subscribe(sis => {
          this.sistema = sis;
        });
    }

    this.fabricanteService.getFabricantes()
      .pipe(
        first())
      .subscribe(fabs => this.fabricantes = fabs);

    this.formulaService.getSistemas()
      .pipe(
        first())
      .subscribe(sis => this.sistemas = sis);

    this.esAdmin = this.keycloackService.isUserInRole('admin');
  }


  buscar() {
    const colorBusqueda: ParamsPlantilla = {
      nombrecolor: this.nombre?.trim(),
      codigocolor: this.codigo?.trim(),
      chip: this.chip?.trim(),
      idsistema: this.sistema?.id,
      idfabricante: this.fabricante?.id,
      activa: this.estadoFormula.valor,
      idformula: this.idformula
    };
    this.isLoading = true;
    this.buscarFormulas(colorBusqueda);
  }


  buscarFormulas(params: ParamsPlantilla) {
    this.colorStore.paramsFormula = params;
    this.formulaService.buscarFormulasColor(params)
      .pipe(first())
      .subscribe(
        colors => {
          this.busquedaIniciada = true;
          this.notificada = false;
          this.isLoading = false;
          this.colorStore.formulas = colors;
        },
        error => {
          this.isLoading = false;
          this.colorStore.formulas = [];
        }
      );
  }

  notificarFormulasNoEncontradas() {
    this.notificacionService.addNotificacion(this.colorStore.paramsFormula).subscribe();
    this.notificada = true;
    this.messageService.add({ severity: 'success', summary: 'Aviso', detail: 'Notificacion realizada' });

  }


  limpiar() {
    this.codigo = "";
    this.nombre = "";
    this.chip = "";
    this.idformula = "";
    this.fabricante = null;
    this.sistema = null;
    this.colorStore.formulas = [];
    this.estadoFormula = { nombre: "Activo", valor: 1 };
    this.resetBusqueda();
  }

  resetBusqueda() {
    this.busquedaIniciada = false;
  }

  iraFormula(fc: FormulaColorView) {
    this.router.navigate(['admin', 'formula', 'sistema',fc.pk.idsistema, 'formula', fc.pk.idformula, 'edit'])
  }
}


interface Activo {
  nombre: string;
  valor: any;
}
